import { useEffect, useRef, useState } from "react";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";
import Spinner from "../Reusable/Spinner";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useSearchParams } from "react-router-dom";
import { useDebounce } from "../../customHooks/useDebounceHook";
import { downloadApiData, postApiFormData } from "../../helpers/AxiosInstance";
import { toast } from "react-toastify";
import moment from "moment";
import Modal from "../Reusable/Modal";
import GroupForm from "./GroupForm";
import EditGroup from "../../pages/DeliveryCharge/EditGroup";

const CargoDeliveryChargeTable = (props: any) => {
  const {
    localServiceBranch,
    localServiceType,
    localProductType = [],
    merchantId,
    id,
  } = props;

  const Product_type = localProductType
    ?.map((item: any) => item?.value)
    ?.join(",");
  const [searchParams, setSearchParms] = useSearchParams({
    searchQuery: "",
  });
  const searchQuery = searchParams.get("searchQuery");
  const debounceSearch = useDebounce(searchQuery);
  const [OpenEditPopup, setOpenEditPopup] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState<string | null>(null);

  const {
    data: deliveryChargeData,
    isLoading: DeliveryChargeLoading,
    isRefetching,
  } = useGetHook({
    queryKey: [
      "delivery-charge",
      `delivery-charge-${localServiceBranch}-${localServiceType}-${merchantId}-${Product_type}-${debounceSearch}-${id}`,
    ],
    url: APIS.CARGO_DELIVERY_CHARGE,
    params: {
      branch: localServiceBranch,
      localServiceType: localServiceType,
      product_type: localProductType
        ?.map((item: any) => item?.value)
        ?.join(","),
      merchant: merchantId,
      delivery_charge_template: id,
      search: debounceSearch,
    },
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [
      "delivery",
      `delivery-${localServiceBranch}-${localServiceType}-${merchantId}-${Product_type}-${debounceSearch}-${id}`,
    ],
    navigateURL: ``,
  });

  const handleDeliveryChargeChange = async (
    destination_city: string,
    product_type: string,
    amount: string,
    weightRange: any
  ) => {
    const url = `${APIS.DELIVERY_CHARGE}`;
    let formData = {
      delivery_charge_template: id,
      pickup_branch: localServiceBranch,
      destination_city: destination_city,
      merchant: merchantId,
      service_type: localServiceType,
      product_type: product_type,
      amount: amount,
      weight_range: weightRange,
    };

    try {
      const res = await mutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };

  const [rerender, setRerender] = useState(true);

  const handleSearch = (value) => {
    searchParams.set("searchQuery", value);
    setSearchParms(searchParams);
  };

  useEffect(() => {
    setRerender(!rerender);
  }, [deliveryChargeData]);
  const handleDownloadSampleFile = async () => {
    const url = APIS.DELIVERY_CHARGE;
    try {
      await downloadApiData(
        `${url}download-bulk-upload-sample-file/`,
        `Sample-${moment().format("MMMM-Do-YYYY-h-mm-ss")}.xlsx`
      );
    } catch (e) {
      console.error(e);
      toast.success("Somethings went wrongs");
    }
  };

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) {
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    formData.append("merchant", merchantId);
    formData.append("service_type", localServiceType);
    formData.append(" delivery_charge_template", id);

    try {
      const url = `${APIS.DELIVERY_CHARGE}bulk-upload/`;
      const res = await postApiFormData({ url, formData, setError: () => {} });
      if (res?.status === 200) {
        toast.success("Uploaded successfully");
      } else {
        toast.error(res?.data?.message ?? "Something went wrong");
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      <div className={tw`w-full min-h-10`}>
        <div className={tw`flex w-full items-center justify-between mb-2`}>
          <div className={tw`w-52`}>
            <input
              type="text"
              placeholder="Search"
              value={searchQuery ?? ""}
              onChange={(e) => handleSearch(e?.target?.value)}
              className={tw`border w-full border-1 border-primary focus:outline-none p-1`}
            />
          </div>
          <div className={tw`grid grid-cols-2 gap-x-2`}>
            <button
              onClick={handleDownloadSampleFile}
              className={tw`text-primary focus:outline-none`}
            >
              Download Sample
            </button>
            <button
              onClick={handleFileUploadClick}
              className={tw`text-primary focus:outline-none`}
            >
              Upload
            </button>
            <input
              type="file"
              accept=".xlsx, .xls"
              ref={fileInputRef}
              onChange={handleFileChange}
              className={tw`hidden`}
            />
          </div>
        </div>
        {DeliveryChargeLoading || isRefetching ? (
          <Spinner />
        ) : (
          <div className={tw`w-full`}>
            {deliveryChargeData?.header?.map((headerItem, hIndex) => {
              const groupCount = Math.floor(
                deliveryChargeData.body.length /
                  deliveryChargeData.header.length
              );
              const bodyStart = hIndex * groupCount;
              const bodyEnd = bodyStart + groupCount;

              const productBody = deliveryChargeData.body.slice(
                bodyStart,
                bodyEnd
              );
              return (
                <div
                  key={headerItem.id}
                  className={tw`border mb-4 p-2 rounded-md bg-white shadow`}
                >
                  <div className={tw``}>
                    <table className={tw`w-full border`}>
                      <thead>
                        <tr>
                          <th
                            className={tw`border px-2 text-left font-semibold`}
                            colSpan={productBody.length + 1}
                          >
                            {headerItem.name}
                          </th>
                        </tr>

                        <tr>
                          <th className={tw`border px-2 whitespace-nowrap`}>
                            Weight (Kg)
                          </th>

                          {productBody.map((group) => (
                            <th
                              key={group.group_id}
                              className={tw`text-center border relative group px-2 cursor-pointer`}
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedGroupId(`${group.group_id}`);
                                setOpenEditPopup(true);
                              }}
                            >
                              {group.name}
                              <div
                                className={tw`absolute left-1/2 top-full mt-1 w-40 -translate-x-1/2 rounded-md bg-white shadow-lg border p-2 text-sm z-10 opacity-0 scale-95 pointer-events-none group-hover:opacity-100 group-hover:scale-100 group-hover:pointer-events-autotransition-all duration-200`}
                              >
                                {group?.countries?.length > 0 ? (
                                  <ul className={tw`text-left`}>
                                    {group.countries.map((c, i) => (
                                      <li key={i}>{c}</li>
                                    ))}
                                  </ul>
                                ) : (
                                  <p className={tw`text-gray-400`}>
                                    No countries
                                  </p>
                                )}
                              </div>
                            </th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {deliveryChargeData?.non_flat_weight_ranges
                          ?.filter(([start, end]) =>
                            headerItem.name === "Document" ? end <= 1 : true
                          )
                          .map(([start, end], rowIndex) => (
                            <tr key={rowIndex} className={tw`border`}>
                              <td className={tw`border px-2 whitespace-nowrap`}>
                                {start} – {end}
                              </td>

                              {productBody.map((group) => (
                                <td
                                  key={group.group_id}
                                  className={tw`border px-2`}
                                >
                                  <input
                                    type="text"
                                    className={tw`bg-transparent w-full text-center`}
                                    defaultValue={group?.rate?.[rowIndex] ?? ""}
                                    onBlur={(e) =>
                                      handleDeliveryChargeChange(
                                        group.group_id,
                                        headerItem?.id,
                                        e.target.value,
                                        [start, end]
                                      )
                                    }
                                  />
                                </td>
                              ))}
                            </tr>
                          ))}

                        {headerItem.name !== "Document" && (
                          <>
                            <tr>
                              <td
                                className={tw`border font-semibold`}
                                colSpan={productBody.length + 1}
                              >
                                Flat rate per kg
                              </td>
                            </tr>

                            {deliveryChargeData?.flat_weight_ranges?.map(
                              ([start, end], idx) => {
                                const isLast =
                                  idx ===
                                  deliveryChargeData.flat_weight_ranges.length -
                                    1;
                                const overallIndex =
                                  idx +
                                  deliveryChargeData.non_flat_weight_ranges
                                    .length;

                                return (
                                  <tr key={overallIndex} className={tw`border`}>
                                    <td
                                      className={tw`border px-2 whitespace-nowrap`}
                                    >
                                      {isLast
                                        ? `${start} and above`
                                        : `${start} – ${end}`}
                                    </td>

                                    {productBody.map((group) => (
                                      <td
                                        key={group.group_id}
                                        className={tw`border px-2`}
                                      >
                                        <input
                                          type="text"
                                          className={tw`bg-transparent w-full text-center`}
                                          defaultValue={
                                            group?.rate?.[overallIndex] ?? ""
                                          }
                                          onBlur={(e) =>
                                            handleDeliveryChargeChange(
                                              group.group_id,
                                              headerItem?.id,
                                              e.target.value,
                                              [start, end]
                                            )
                                          }
                                        />
                                      </td>
                                    ))}
                                  </tr>
                                );
                              }
                            )}
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <Modal
        isOpen={OpenEditPopup}
        setIsOpen={() => {
          setOpenEditPopup(false);
        }}
        title={"Add Countries"}
      >
        <EditGroup
          id={selectedGroupId}
          closeModal={() => {
            setOpenEditPopup(false);
          }}
        />
      </Modal>
    </>
  );
};

export default CargoDeliveryChargeTable;
